module.exports = __webpack_public_path__ + "static/media/invite-guest-expired.c0f1a881.svg";